import React from 'react';
import LegalLayout from './LegalLayout';

const Mentions = () => (
  <LegalLayout title="Mentions légales" slug="mentions" lastUpdated="27 octobre 2026">
    <h2>1. Éditeur du site</h2>
    <p>Le site OpenSapiens (<a href="https://app.opensapiens.ch">https://app.opensapiens.ch</a>) est édité par :</p>
    <ul>
      <li><strong>Éditeur :</strong> OpenSapiens — propriétaire des domaines opensapiens.ch et opensapiens.io</li>
      <li><strong>Statut :</strong> Structure juridique en cours de constitution</li>
      <li><strong>Adresse :</strong> Genève, Suisse</li>
      <li><strong>Email :</strong> <a href="mailto:info@opensapiens.ch">info@opensapiens.ch</a></li>
    </ul>
    <p>
      <em>Note Beta : La structure juridique est en cours de création. Les présentes mentions seront
      mises à jour dès l'obtention de l'IDE (Identifiant d'Entreprise suisse) et de l'inscription au
      registre du commerce.</em>
    </p>

    <h2>2. Directeur de la publication</h2>
    <p>OpenSapiens — propriétaire des domaines opensapiens.ch et opensapiens.io</p>

    <h2>3. Hébergement</h2>
    <p>
      Le site est hébergé via la plateforme <strong>Emergent</strong>, avec serveurs en Europe et
      utilisation de <strong>Cloudflare</strong> comme CDN et protection contre les attaques. La base
      de données est hébergée par <strong>MongoDB Atlas</strong> (région UE).
    </p>

    <h2>4. Propriété intellectuelle</h2>
    <p>
      L'ensemble des éléments accessibles sur le site (textes, images, vidéos, graphismes, logos,
      icônes, marques, structure du site) sont la propriété exclusive de l'Éditeur ou de ses
      partenaires, et sont protégés par les lois suisses et internationales relatives à la propriété
      intellectuelle.
    </p>
    <p>
      Toute reproduction, représentation, modification, publication, transmission ou exploitation
      partielle ou totale est strictement interdite sans autorisation préalable et écrite de l'Éditeur.
    </p>

    <h2>5. Données personnelles</h2>
    <p>
      Les modalités de traitement des données personnelles sont détaillées dans la
      <a href="/legal/privacy"> Politique de confidentialité</a>. Conformément au RGPD et à la LPD,
      l'Utilisateur dispose d'un droit d'accès, de rectification, d'effacement et d'opposition.
    </p>

    <h2>6. Conditions d'utilisation</h2>
    <p>
      L'accès et l'utilisation du site sont régis par les
      <a href="/legal/cgu"> Conditions Générales d'Utilisation</a>.
    </p>

    <h2>7. Cookies</h2>
    <p>
      Seuls des cookies strictement nécessaires au fonctionnement du service sont utilisés. Aucun
      cookie publicitaire ou de pistage tiers n'est déposé. Voir la
      <a href="/legal/privacy"> Politique de confidentialité</a> pour plus d'informations.
    </p>

    <h2>8. Limitation de responsabilité</h2>
    <p>
      L'Éditeur met tout en œuvre pour offrir aux Utilisateurs des informations et outils disponibles
      et vérifiés, mais ne saurait être tenu pour responsable des erreurs, d'une indisponibilité
      temporaire des services, ou de la présence d'éventuels virus sur le site.
    </p>

    <h2>9. Droit applicable</h2>
    <p>
      Le présent site et les présentes mentions sont régis par le droit suisse. Tout litige relatif à
      l'interprétation ou à l'exécution sera porté devant les tribunaux compétents de Genève.
    </p>

    <h2>10. Contact</h2>
    <p>
      Pour toute question relative au site ou aux présentes mentions légales :
      <a href="mailto:info@opensapiens.ch"> info@opensapiens.ch</a>
    </p>
  </LegalLayout>
);

export default Mentions;
